export { default } from './DownloadBrochureView';



// WEBPACK FOOTER //
// ./src/components/views/DownloadBrochureView/index.js